import { type Localization } from './Interface'

export const localizationEn: Localization = {
  country: {
    BE: {
      text: 'Belgium',
    },
    BG: {
      text: 'Bulgaria',
    },
    CZ: {
      text: 'Czech Republic',
    },
    DK: {
      text: 'Denmark',
    },
    DE: {
      text: 'Germany',
    },
    EE: {
      text: 'Estonia',
    },
    IE: {
      text: ' Ireland',
    },
    EL: {
      text: 'Greece',
    },
    ES: {
      text: 'Spain',
    },
    FR: {
      text: 'France',
    },
    HR: {
      text: 'Croatia',
    },
    IT: {
      text: 'Italy',
    },
    CY: {
      text: 'Cyprus',
    },
    LV: {
      text: 'Latvia',
    },
    LT: {
      text: 'Lithuania',
    },
    LU: {
      text: 'Luxembourg',
    },
    HU: {
      text: 'Hungary',
    },
    MT: {
      text: 'Malta',
    },
    NL: {
      text: 'Netherlands',
    },
    AT: {
      text: 'Austria',
    },
    PL: {
      text: 'Poland',
    },
    PT: {
      text: 'Portugal',
    },
    RO: {
      text: 'Romania',
    },
    SI: {
      text: 'Slovenia',
    },
    SK: {
      text: 'Slovakia',
    },
    FI: {
      text: 'Finland',
    },
    SE: {
      text: 'Sweden',
    },
    IS: {
      text: 'Iceland',
    },
    LI: {
      text: 'Liechtenstein',
    },
    NO: {
      text: 'Norway',
    },
    CH: {
      text: 'Switzerland',
    },
    UK: {
      text: ' United Kingdom',
    },
    US: {
      text: 'United States',
    },
  },
  'top-menu': {
    logout: {
      text: 'Logout',
    },
    'certificate-list': {
      text: 'Certificates',
    },
    'company-list': {
      text: 'Companies',
    },
    'certificate-instance-list': {
      text: 'Certification bodies',
    },
    'user-list': {
      text: 'Users',
    },
    'certificate-type-list': {
      text: 'Certificate types',
    },
    'logging-list': {
      text: 'Logging',
    },
    login: {
      text: 'Login',
    },
  },
  certificate: {
    'add-company': {
      text: 'Add certificate',
    },
    'filter-company-postcode-label': {
      text: 'Postal code',
    },
    'filter-company-postcode-helper': {
      text: 'Enter (part of) the zip code of a linked company',
    },
    'filter-company-input-label': {
      text: 'Company ',
    },
    'filter-company-input-helper': {
      text: 'Enter (part of) the name of the company',
    },
    'filter-certificate-type-input-label': { text: 'Certificate type' },
    'filter-certificate-type-input-helper': {
      text: 'Choose a certificate type',
    },
    'filter-status-input-label': { text: 'Status' },
    'filter-status-input-helper': {
      text: 'Choose a status',
    },
    'filter-scope-input-label': {
      text: ' Scope',
    },
    'filter-scope-input-helper': {
      text: 'Enter (part of) the scope',
    },
    certificateNumber: {
      text: 'Certificate number',
    },
    companyBranches: {
      text: 'Enterprise(s)',
    },
    certificateInstanceVatNumber: {
      text: 'Certificate authority',
    },
    certificateInstanceName: { text: 'Certificate authority' },
    companyNames: { text: 'Company(s)' },
    calculatedStatus: { text: 'Status' },
    companyPostcodes: { text: 'Company zip codes' },
    status: {
      text: 'Status',
    },
    type: {
      text: 'Type',
    },
    edit: {
      text: 'Edit certificate',
    },
    delete: { text: 'Remove certificate' },
    naceCodes: {
      text: 'NACE codes',
    },
    scope: {
      text: 'Scope',
    },
    certificateInstances: {
      text: 'Certification authority',
    },
    issueDate: {
      text: 'Issued on',
    },
    validFrom: {
      text: 'Valid from',
    },
    validUntil: {
      text: 'Valid until',
    },
    'scope-max-length-helper': {
      text: '{remainingLength}/{maxLength} characters remaining',
      parameters: ['remainingLength', 'maxLength'],
    },
    isGroupCertificate: {
      text: 'Is multi-establishment',
    },
    addCompanyBranch: {
      text: 'Select company or type VAT number',
    },
    'add-companyBranch': {
      text: 'Select existing company',
    },
    'create-new-company': {
      text: 'Or create new business',
    },
    Valid: {
      text: 'Valid',
    },
    Prolonged: {
      text: ' Prolonged',
    },
    Suspended: {
      text: 'Suspended',
    },
    Withdrawn: {
      text: 'Withdrawn',
    },
    extendedUntil: {
      text: 'Extended until',
    },
    'safe-add-button': {
      text: 'Add certificate',
    },
    'type-missing': {
      text: 'Select a valid type',
    },
    'certificateNumber-missing': {
      text: 'Enter a valid certificate number',
    },
    'naceCodes-missing': {
      text: 'Enter at least one valid NACE code',
    },
    'scope-missing': {
      text: 'Enter a valid scope',
    },
    'companyBranches-missing': {
      text: 'Choose at least one company and branch',
    },
    'certificateInstanceVatNumber-missing': {
      text: 'Choose a certificate authority',
    },
    'extendedUntil-missing': {
      text: 'Please enter a valid date',
    },
    'filter-company-postcodes-input-label': {
      text: 'Postcodes',
    },
    'filter-company-postcodes-input-helper': {
      text: 'Enter comma separated zip codes for companies',
    },
    'any-certificate-type': { text: 'All certificate types' },
    'any-certificate-instance': { text: 'All certificate authorities' },
    'filter-certificate-instance-input-label': { text: 'Certification body' },
    'filter-certificate-instance-input-helper': {
      text: 'Choose a certificate authority',
    },
    'filter-certificate-number-input-label': {
      text: 'Certificate number',
    },
    'filter-certificate-number-input-helper': {
      text: 'Enter (part of) the certificate number',
    },
  },
  'logging-list': {
    'filter-email-input-label': {
      text: 'Email',
    },
    'filter-email-input-helper': {
      text: "Enter (part of) the user's email address",
    },
    'filter-action-input-label': {
      text: 'Action',
    },
    'filter-action-input-helper': {
      text: 'Enter (part of) action',
    },
    changeDate: {
      text: 'Date',
    },
    userEmail: {
      text: 'Email',
    },
    action: {
      text: 'Action',
    },
    details: {
      text: 'Details',
    },
  },
  'certificate-add': {
    type: {
      text: 'Type',
    },
    certificateNumber: {
      text: 'Certificate number',
    },
    naceCodes: {
      text: 'NACE codes',
    },
    scope: {
      text: 'Scope',
    },
    'scope-max-length-helper': {
      text: '{remainingLength}/{maxLength} characters remaining',
      parameters: ['remainingLength', 'maxLength'],
    },
    isGroupCertificate: {
      text: 'Is multi-establishment',
    },
    companyBranches: {
      text: 'Companies and branches',
    },
    addCompanyBranch: {
      text: 'Select company or type VAT number',
    },
    'add-companyBranch': {
      text: 'Select existing company',
    },
    'create-new-company': {
      text: 'Or create new business',
    },
    status: {
      text: 'Status',
    },
    Valid: {
      text: 'Valid',
    },
    Prolonged: {
      text: 'Prolonged',
    },
    Suspended: {
      text: 'Suspended',
    },
    Withdrawn: {
      text: 'Withdrawn',
    },
    certificateInstances: {
      text: 'Certification instance',
    },
    issueDate: {
      text: 'Issued on',
    },
    validFrom: {
      text: 'Valid from',
    },
    validUntil: {
      text: 'Valid until',
    },
    extendedUntil: {
      text: 'Extended until',
    },
    'safe-edit-button': {
      text: 'Save',
    },
    'certificate-save-in-progress': {
      text: ' The certificate is currently being saved.',
    },
    'companyBranches-not-selected': {
      text: 'Choose at least one location',
    },
  },
  components: {
    'select-from-list': {
      text: 'Select from list',
    },
    'select-no-options-match-search': {
      text: 'No options match the search term',
    },
    'data-being-loaded': { text: 'The data is currently being loaded.' },
    loading: { text: '...' },
  },
  company: {
    'add-company': {
      text: 'Add company',
    },
    'vat-number': {
      text: 'Company number',
    },
    'invalid-vat-number': {
      text: 'Enter a valid vat number starting with the country code',
    },
    name: {
      text: 'Naam',
    },
    'legal-form': {
      text: 'Legal form',
    },
    email: {
      text: 'Email',
    },
    website: {
      text: 'Website',
    },
    addressLine1: {
      text: 'Street and house number',
    },
    postalCode: {
      text: 'Postcode',
    },
    city: {
      text: 'Municipality',
    },
    country: {
      text: 'Country',
    },
    naceCode: {
      text: 'NACE Code',
    },
    'accident-counts': {
      text: 'Work accident figures',
    },
    branches: {
      text: 'Locations',
    },
    'safe-add-button': {
      text: 'Add company',
    },
    'filter-vat-number-input-label': {
      text: 'Company number',
    },
    'filter-vat-number-input-helper': {
      text: 'Enter (part of) the company number',
    },
    'filter-company-input-label': {
      text: 'Company',
    },
    'filter-company-input-helper': {
      text: 'Enter (part of) the name of the company',
    },
    vatNumber: {
      text: 'Company number',
    },
    legalForm: {
      text: ' Legal form',
    },
    edit: {
      text: 'Edit company',
    },
    delete: { text: 'Remove company' },
    'nace-code': {
      text: 'NACE Code',
    },
    certificates: {
      text: 'Certificates',
    },
    'reload-vat-info': {
      text: 'Reload company information',
    },
    'add-accident-count': {
      text: 'Add year',
    },
    'safe-edit-button': {
      text: 'Save',
    },
    'vat-info-fetch-in-progress': {
      text: 'Fetching data for company {vatNumber}',
      parameters: ['vatNumber'],
    },
    'remove-accident-count': {
      text: 'Remove year',
    },
    'company-save-in-progress': {
      text: 'The company is currently being saved.',
    },
    lastKpbCheck: { text: 'Last KBO synchronization' },
    'change-company-vat': { text: 'Change company registration number' },
    'old-vat-number': {
      text: 'Change company number {vatNumber}',
      parameters: ['vatNumber'],
    },
    'change-vat': { text: 'Change registration number' },
    'confirm-company-delete': {
      text: 'Are you sure you want to delete this company?',
    },
    'confirm-certificate-delete': {
      text: 'Are you sure you want to delete this certificate?',
    },
    'kbo-success': { text: 'Success' },
    'kbo-failure': { text: 'Failure' },
  },
  'certificate-instance': {
    'add-certificate-instance': {
      text: 'Add certificate instance',
    },
    'filter-name-input-label': {
      text: 'Name',
    },
    'filter-name-input-helper': {
      text: 'Enter (part of) the name of the certificate authority',
    },
    name: {
      text: 'Name',
    },
    addressLine1: {
      text: 'Street and house number',
    },
    postalCode: {
      text: 'Postcode',
    },
    city: {
      text: 'Municipality',
    },
    countryCode: {
      text: 'Country',
    },
    'vat-number': {
      text: 'Company number',
    },
    'invalid-vat-number': {
      text: 'Enter a valid vat number starting with the country code',
    },
    email: {
      text: 'Email',
    },
    website: {
      text: 'Website',
    },
    telephone: {
      text: 'Telephone',
    },
    country: {
      text: 'Country',
    },
    coordinators: {
      text: 'VCA coordinators',
    },
    'safe-add-button': {
      text: 'Add certificate authority',
    },
    edit: {
      text: 'Edit certificate authority',
    },
    delete: { text: 'Remove certificate authority' },
    'coordinator-name': {
      text: 'Name',
    },
    'coordinator-email': {
      text: 'Email',
    },
    'coordinator-telephone': {
      text: 'GSM',
    },
    certificates: {
      text: 'Certificates',
    },
    'reload-vat-info': {
      text: 'Reload company information',
    },
    'remove-coordinator': {
      text: 'Remove coordinator',
    },
    'add-coordinator': {
      text: 'Add VCA coordinator',
    },
    'safe-edit-button': {
      text: 'Save',
    },
    'name-missing': {
      text: 'Enter a valid name in',
    },
    'email-missing': {
      text: 'Enter a valid email address',
    },
    'vat-info-fetch-in-progress': {
      text: 'Data for company {vatNumber} are retrieved',
      parameters: ['vatNumber'],
    },
    'email-invalid': {
      text: 'Email format is incorrect',
    },
    'website-invalid': {
      text: 'Website format is incorrect ',
    },
    'telephone-required': { text: 'Cell phone is mandatory' },
    'telephone-invalid': {
      text: 'Phone format is incorrect',
    },
    'certificate-instance-save-in-progress': {
      text: 'The certificate instance is currently being saved.',
    },
    'confirm-certificate-instance-delete': {
      text: 'Are you sure you want to delete this certificate authority?',
    },
  },
  'user-list': {
    'add-user': {
      text: 'Add user',
    },
    'filter-email-input-label': {
      text: 'Email',
    },
    'filter-email-input-helper': {
      text: "Enter (part of) the user's email address",
    },
    email: {
      text: 'Email',
    },
    isAdmin: {
      text: 'Is administrator',
    },
    certificateInstanceVatNumber: {
      text: 'Certificate instance',
    },
  },
  user: {
    email: {
      text: 'Email',
    },
    'is-admin': {
      text: 'Is administrator',
    },
    'certificate-instance': {
      text: 'Certificate instance',
    },
    'remove-button': {
      text: 'Remove user',
    },
    'safe-add-button': {
      text: 'Add user',
    },
    'email-invalid': {
      text: 'Email format is incorrect',
    },
    'user-save-in-progress': {
      text: 'The user currently being saved.',
    },
    'delete-user-prompt': {
      text: 'Are you sure you want to permanently delete this user?',
    },
    'user-delete-in-progress': {
      text: 'The user is currently being deleted.',
    },
  },
  'certificate-type': {
    'add-certificate-type': {
      text: 'Add certificate type',
    },
    'filter-name-input-label': {
      text: 'Name',
    },
    'filter-name-input-helper': {
      text: 'Enter (part of) the name of the certificate type',
    },
    'filter-is-active-input-label': {
      text: 'Is active',
    },
    'filter-is-active-input-helper': {
      text: 'Is it active or not',
    },
    yes: {
      text: ' is active',
    },
    no: {
      text: 'is not active',
    },
    'filter-nace-limitation-input-label': {
      text: 'NACE limitation',
    },
    'filter-nace-limitation-input-helper': {
      text: 'Enter (part of) the NACE constraint',
    },
    name: {
      text: 'Name',
    },
    isActive: {
      text: 'Is active',
    },
    naceLimitation: {
      text: 'Limited to NACE codes',
    },
    'safe-add-button': {
      text: 'Add certificate',
    },
    'name-missing': {
      text: 'Enter a valid certificate type name',
    },
  },
  'certificate-type-add': {
    name: {
      text: 'Name',
    },
    isActive: {
      text: 'Is active',
    },
    naceLimitation: {
      text: 'Limited to NACE codes',
    },
    'safe-edit-button': {
      text: 'Save',
    },
    'certificate-type-save-in-progress': {
      text: 'The certificate type is currently being saved.',
    },
  },
  login: {
    'login-email': {
      text: 'Login email',
    },
    'login-button': {
      text: 'Login',
    },
    'login-email-send': {
      text: 'If the email is linked to an account. We have sent a login link to the specified email address. click this link to log in.',
    },
  },
  'certificate-statuses': {
    'any-status': { text: 'Any statuses' },
    Expired: { text: 'Expired' },
    Valid: { text: 'Valid' },
    Prolonged: { text: 'Prolonged' },
    Suspended: { text: 'Suspended' },
    Withdrawn: { text: 'Withdrawn' },
  },
  general: {
    cancel: { text: 'Cancel' },
    save: { text: 'Save' },
  },
}
